module.exports = __webpack_public_path__ + "img/Turkey.019d553e.jpg";